import * as React from "react";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import ActiveList from "./ActiveList";
import WaitingOnOthers from "./WaitingOnOthers";
import WaitingOnYou from "./WaitingOnYou";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { PROXY_APPROVED, PROXY_DECLINED, EPIC, RX, PENDING_STATUS, APPROVED_STATUS, EXPIRED_STATUS, CANCELLED_STATUS, DECLINED_STATUS } from "../../constants/textConstants";
import * as ProxyHelper from "./ProxyHelper";
import { Typography, Button } from "../ecosystem";
import FamilyManagementCard from "./FamilyManagementCard";
import MedicalSubjects from "./home/MedicalSubjects";
import RXSubjects from "./home/RXSubjects";
import ErrorMsg from "./home/ErrorMsg";
import LinkRecord from "./home/LinkRecord";

const NOTAUTHORIZED = "You are not authorized to approve this request. The requester can resend the request if you feel this is an error.";
const UNABLETOAPPROVE = "We're sorry, we currently are unable to approve this request.";
const UNABLETODECLINE = "We're sorry, we currently are unable to decline this request.";

class MySubjects extends React.Component {

    constructor(props) {
        super(props);
        this.approvedRequest = null;
        this.declinedRequest = null;
        this.state = { declinedRequest: null };
    }

    componentDidMount() {
        this.props.setTimeoutMessage('');
        logUI("MBHWeb.UI.MySubjects.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
    }

    onApprove(grant) {
        const { changeRequestStatus } = this.props;
        logUI(`MBHWeb.UI.MySubjects.Approve${ProxyHelper.getLogProxySource(grant.ProxySource)}Grant`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: grant.ProxyRequestId }));
        this.approvedRequest = grant;
        this.declinedRequest = null;
        this.setState({ declinedRequest: null });

        //this.props.setTimeoutMessage(PROXY_APPROVED);
        //changeRequestStatus(grant.ProxyRequestId, grant.ProxySource, grant.RequestType, PROXY_APPROVED);
        let url = `/proxygrant/accept/${grant.ProxyRequestId}/${grant.ProxySource}/${btoa(grant.proxyName)}`;
        this.props.history.push(url);

    }

    onDecline(grant) {
        logUI(`MBHWeb.UI.MySubjects.Decline${ProxyHelper.getLogProxySource(grant.ProxySource)}Grant`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: grant.ProxyRequestId }));
        this.approvedRequest = null;
        this.declinedRequest = grant;
        const { declineProxyWithReason } = this.props;
        if (declineProxyWithReason) {
            this.setState({ declinedRequest: grant });
        }
        else {
            this.props.setTimeoutMessage(PROXY_DECLINED);
            this.props.changeRequestStatus(grant.ProxyRequestId, grant.ProxySource, grant.RequestType, PROXY_DECLINED);
            //let url = `/proxygrant/decline/${grant.ProxyRequestId}/${grant.ProxySource}/${btoa(grant.proxyName)}`;
            //this.props.history.push(url);
        }
    }

    getDeclineErrorMessage(rsp) {
        let errorMessage = null;
        if (rsp && typeof rsp === "string") {
            switch (rsp) {
                case "Internal Server Error":
                    errorMessage = UNABLETODECLINE;
                    break;
                case "Conflict":
                    errorMessage = "This request has already been processed.";
                    break;
                default:
                    errorMessage = UNABLETODECLINE;
                    break;
            }
        }
        else if (rsp && rsp.message) {
            errorMessage = "You are not authorized to decline this request"; //this is not applicable but having it.
        }
        else {
            errorMessage = rsp;
        }

        return errorMessage;
    }

    // Get Error Message from changeRequestStatus response.
    getErrorMessage(status, rsp) {
        let errorMessage = null;
        if (status === 'failure') {
            if (rsp && typeof rsp === "string") {
                switch (rsp) {
                    case "Internal Server Error":
                        errorMessage = UNABLETOAPPROVE;
                        break;
                    case "Conflict":
                        errorMessage = "This request has already been processed.";
                        break;
                    default:
                        errorMessage = UNABLETOAPPROVE;
                        break;
                }
            }
            else if (rsp && rsp.message) {
                errorMessage = NOTAUTHORIZED;
            } else if (rsp && typeof (rsp) === "object" && !rsp.message) {
                errorMessage = UNABLETOAPPROVE;
            }
            else {
                errorMessage = rsp;
            }
        }
        return errorMessage;
    }

    requestAccess(e) {
        this.props.initializeRequestData();
        this.props.history.push("/proxyrequestDOB");
    }

    render() {
        const { actionType, grantPharmacyList, grantEpicList, pharmacyList, epicSubjectList, hasMychartLogin, hasPharmacyLogin, showGrantProxyAccess,
            age, epicSubjectFailure, pharmacyError, showAccessAndProxiesList, emailProxyRequestId, emailProxyRequestErrMsg, changeRequestStatusAction,
            enableProxyGrantPharmacy, enableProxyRequestV2, requestEpicList, removeBSWPharmacy } = this.props;

        // Set ApproveRequest for showing Approval status message on email proxy request
        if (emailProxyRequestId && !emailProxyRequestErrMsg) {
            this.approvedRequest = grantEpicList && grantEpicList.filter(account => account.ProxyRequestId && typeof account.ProxyRequestId === 'string' && account.ProxyRequestId.toLowerCase() === emailProxyRequestId)[0];
            if (!this.approvedRequest)
                this.approvedRequest = grantPharmacyList && grantPharmacyList.filter(account => account.ProxyRequestId && typeof account.ProxyRequestId === 'string' && account.ProxyRequestId.toLowerCase() === emailProxyRequestId)[0];
            this.declinedRequest = null;
        }

        //Pending Grant pharmacy list.
        const pendingGrantPharmacyList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasPendingGrantPharmacyList = pendingGrantPharmacyList && pendingGrantPharmacyList.length > 0;

        //Pending Grant medicalrecords list.
        const pendingGrantEpicList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasPendingGrantEpicList = pendingGrantEpicList && pendingGrantEpicList.length > 0;

        //Approved Grant pharmacy list.
        let grantPharmacyActiveList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasGrantPharmacyActiveList = grantPharmacyActiveList && grantPharmacyActiveList.length > 0;

        //Expired Grant medical records list
        let grantEpicExpiredList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        const hasGrantEpicExpiredList = grantEpicExpiredList && grantEpicExpiredList.length > 0;

        //Expired Grant pharmacy records list
        let grantPharmacyExpiredList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        const hasGrantPharmacyExpiredList = grantEpicExpiredList && grantEpicExpiredList.length > 0;

        //Expired Grant pharmacy records list
        let grantPharmacyCancelledList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        const hasGrantPharmacyCancelledList = grantPharmacyCancelledList && grantPharmacyCancelledList.length > 0;

        //Approved Grant medicalrecords list.
        let grantEpicActiveList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasGrantEpicActiveList = grantEpicActiveList && grantEpicActiveList.length > 0;

        const pharmacyPendingList = pharmacyList && pharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasPharmacyPendingList = pharmacyPendingList && pharmacyPendingList.length > 0;

        const pharmacyActiveList = pharmacyList && pharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasPharmacyActiveList = pharmacyActiveList && pharmacyActiveList.length > 0;
        //const pharmacyDeclineList = pharmacyList && pharmacyList.filter(account => account.Status === 'Declined');
        //const hasPharmacydeclineList = pharmacyDeclineList && pharmacyDeclineList.length > 0;

        const epicActiveSubjectList = (typeof epicSubjectList !== "undefined") && epicSubjectList;
        const hasEpicActiveSubject = epicActiveSubjectList && epicActiveSubjectList.length > 0;

        //Cancelled Grant medical records list.
        const grantEpicCancelledList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        const hasGrantEpicCancelledList = grantEpicCancelledList && grantEpicCancelledList.length > 0;

        //Epic request active list
        const requestEpicActiveList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasRequestEpicActiveList = requestEpicActiveList && requestEpicActiveList.length > 0;

        //Pending Request Medical Reocrds List.
        let requestEpicPendingList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        let hasRequestEpicPendingList = requestEpicPendingList && requestEpicPendingList.length > 0;
        //Cancelled Request Medical Records lsit.
        let requestEpicCancelledList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        let hasRequestEpicCancelledList = requestEpicCancelledList && requestEpicCancelledList.length > 0;

        //Cancelled Request pharmacy Records list.
        let requestRxCancelledList = pharmacyList && pharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        let hasRequestRxCancelledList = requestRxCancelledList && requestRxCancelledList.length > 0;

        //Expired Request pharmacy Records list.
        let requestRxExpiredList = pharmacyList && pharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        let hasRequestRxExpiredList = requestRxExpiredList && requestRxExpiredList.length > 0;

        //Declined Request pharmacy Records list.
        let requestRxDeclinedList = pharmacyList && pharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === DECLINED_STATUS);
        let hasRequestRxDeclinedList = requestRxDeclinedList && requestRxDeclinedList.length > 0;

        //Expired Request Medical Records
        let requestEpicExpiredList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        let hasRequestEpicExpiredList = requestEpicExpiredList && requestEpicExpiredList.length > 0;
        //Declined Request Medical List
        let requestEpicDeclinedList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === DECLINED_STATUS);
        let hasRequestEpicDeclinedList = requestEpicDeclinedList && requestEpicDeclinedList.length > 0;

        const isAdult = age && age > 17 ? true : false;
        const isChangeRequestActionApproveWaiting = changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_APPROVED && changeRequestStatusAction.waiting;
        const approvedRequestSuccess = changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_APPROVED && !changeRequestStatusAction.waiting &&
            this.approvedRequest && changeRequestStatusAction.request.proxyRequestId === this.approvedRequest.ProxyRequestId && changeRequestStatusAction.success;
        const approveRequestId = this.approvedRequest && this.approvedRequest.ProxyRequestId;
        var approveErrorMessage = !emailProxyRequestErrMsg && changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_APPROVED ? this.getErrorMessage("failure", changeRequestStatusAction.error) : "";

        const isChangeRequestActionDeclineWaiting = changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_DECLINED && changeRequestStatusAction.waiting;
        const declineRequestId = this.declinedRequest && this.declinedRequest.ProxyRequestId;
        const declineErrorMessage = !emailProxyRequestErrMsg && changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_DECLINED ? this.getDeclineErrorMessage(changeRequestStatusAction.error) : "";
        const showNoAccountRequestV2Rx = enableProxyRequestV2 ? !hasRequestRxCancelledList && !hasRequestRxDeclinedList && !hasRequestRxExpiredList : true;
        const showNoAccountsGrantRx = enableProxyGrantPharmacy ? !hasGrantPharmacyActiveList && !hasPendingGrantPharmacyList && !hasGrantPharmacyCancelledList && !hasGrantPharmacyExpiredList : true;
        const showNoAccountsManaged = !showGrantProxyAccess ? hasPharmacyLogin && !hasPharmacyPendingList && !hasPharmacyActiveList && !pharmacyError && showNoAccountRequestV2Rx
            : hasPharmacyLogin && !hasPharmacyPendingList && !hasPharmacyActiveList && !pharmacyError && showNoAccountsGrantRx && showNoAccountRequestV2Rx;

        const medicalRecord = <>

            {!hasMychartLogin
                ? <LinkRecord
                    to={{
                        pathname: '/linkedaccounts',
                        searchParams: "openMyChart=true"
                    }}
                />
                : <MedicalSubjects
                    showNotManaging={(showGrantProxyAccess
                        ? (!hasGrantEpicActiveList && !hasRequestEpicActiveList)
                        : (!hasEpicActiveSubject && !epicSubjectFailure)
                    )}
                >
                    {hasRequestEpicActiveList && hasMychartLogin &&
                        <div className="row active-list-container">
                            <div className="col-12">
                                <ActiveList requestList={requestEpicActiveList} proxySource={EPIC} referrer="subject" />
                            </div>
                        </div>
                    }

                    {!showGrantProxyAccess && hasMychartLogin && hasEpicActiveSubject &&
                        <div className="row active-list-container">
                            <div className="col-12">
                                <ActiveList grantOrSubjectList={epicActiveSubjectList}
                                    proxySource={EPIC}
                                    referrer="acceptgrant"
                                    approvedRequest={this.approvedRequest}
                                    isApprovePending={isChangeRequestActionApproveWaiting}
                                    approveRequestId={approveRequestId}
                                    approvedRequestSuccess={approvedRequestSuccess}
                                    actionType={actionType}
                                />
                            </div>
                        </div>
                    }
                    {showGrantProxyAccess && hasMychartLogin && hasGrantEpicActiveList &&
                        <div className="row active-list-container">
                            <div className="col-12">
                                <ActiveList grantOrSubjectList={grantEpicActiveList}
                                    proxySource={EPIC}
                                    referrer="acceptgrant"
                                    approvedRequest={this.approvedRequest}
                                    isApprovePending={isChangeRequestActionApproveWaiting}
                                    approveRequestId={approveRequestId}
                                    approvedRequestSuccess={approvedRequestSuccess}
                                    actionType={actionType}
                                />
                            </div>
                        </div>
                    }
                    {/*Show request v2 epic pending list */}
                    {enableProxyRequestV2 && hasMychartLogin && hasRequestEpicPendingList &&
                        <div className="row pending-list-container">
                            <div className="col-12">
                                <WaitingOnOthers
                                    listEpic={requestEpicPendingList}
                                    proxySource={EPIC}
                                />
                            </div>
                        </div>
                    }
                    {showGrantProxyAccess && hasMychartLogin && hasPendingGrantEpicList &&
                        <div className="row pending-list-container">
                            <div className="col-12">
                                <WaitingOnYou
                                    grantEpicList={pendingGrantEpicList}
                                    onApprove={grant => this.onApprove(grant)}
                                    onDecline={grant => this.onDecline(grant)}
                                    proxySource={EPIC}
                                    isApprovePending={isChangeRequestActionApproveWaiting}
                                    approveRequestId={approveRequestId}
                                    approveErrorMessage={approveErrorMessage}
                                    isDeclinePending={isChangeRequestActionDeclineWaiting}
                                    declineRequestId={declineRequestId}
                                    declineErrorMessage={declineErrorMessage}
                                    actionType={actionType}
                                />
                            </div>
                        </div>
                    }
                    {/*Show request v2 epic Cancelled list */}
                    {
                        enableProxyRequestV2 && hasMychartLogin && hasRequestEpicCancelledList &&
                        <div className="row cancelled-list-container">
                            <div className="col-12">
                                <WaitingOnOthers
                                    proxySource={EPIC}
                                    hasRequestEpicCancelledList={hasRequestEpicCancelledList}
                                    requestEpicCancelledList={requestEpicCancelledList} />
                            </div>
                        </div>
                    }
                    {/*Show grant epic Cancelled list */}
                    {showGrantProxyAccess && hasMychartLogin && hasGrantEpicCancelledList &&
                        <div className="row cancelled-list-container">
                            <div className="col-12">
                                <WaitingOnYou
                                    proxySource={EPIC}
                                    hasGrantEpicCancelledList={hasGrantEpicCancelledList}
                                    grantEpicCancelledList={grantEpicCancelledList}
                                />
                            </div>
                        </div>
                    }
                    {/*Show request v2 epic declined list */}
                    {enableProxyRequestV2 && hasMychartLogin && hasRequestEpicDeclinedList &&
                        <div className="row cancelled-list-container">
                            <div className="col-12">
                                <WaitingOnOthers
                                    proxySource={EPIC}
                                    hasRequestEpicDeclinedList={hasRequestEpicDeclinedList}
                                    requestEpicDeclinedList={requestEpicDeclinedList}
                                />
                            </div>
                        </div>
                    }
                    {/*Show request v2 epic expired list */}
                    {enableProxyRequestV2 && hasMychartLogin && hasRequestEpicExpiredList &&
                        <div className="row declined-list-container">
                            <div className="col-12">
                                <WaitingOnOthers
                                    proxySource={EPIC}
                                    hasRequestEpicExpiredList={hasRequestEpicExpiredList}
                                    requestEpicExpiredList={requestEpicExpiredList} />
                            </div>
                        </div>
                    }

                    {showGrantProxyAccess && hasMychartLogin && hasGrantEpicExpiredList &&
                        <div className="row declined-list-container">
                            <div className="col-12">
                                <WaitingOnYou
                                    proxySource={EPIC}
                                    grantEpicExpiredList={grantEpicExpiredList}
                                    hasGrantEpicExpiredList={hasGrantEpicExpiredList}
                                />
                            </div>
                        </div>
                    }

                </MedicalSubjects>
            }

            {
                !showGrantProxyAccess && showAccessAndProxiesList && epicSubjectFailure &&
                <ErrorMsg message="We are not able to show these accounts. Please try again later." />
            }

        </>

        return ((this.state.declinedRequest ? <Redirect to={{ pathname: '/proxygrant/decline/', state: { declinedRequest: this.state.declinedRequest } }} /> :
            <div className="current__subjects">
                
                    
                {removeBSWPharmacy ?
                    <FamilyManagementCard>
                        {medicalRecord}
                    </FamilyManagementCard>

                    :
                    <FamilyManagementCard title="Medical">
                        {medicalRecord}
                    </FamilyManagementCard>


                    }
               

                {!removeBSWPharmacy &&

                    <FamilyManagementCard title="BSW Pharmacy">

                        <RXSubjects
                            showNotManaging={showNoAccountsManaged}
                        >
                            {hasPharmacyActiveList &&
                                <div className="row active-list-container">
                                    <div className="col-12">
                                        <ActiveList requestList={pharmacyActiveList} proxySource={RX} referrer="subject" />
                                    </div>
                                </div>
                            }
                            {showGrantProxyAccess && enableProxyGrantPharmacy && hasGrantPharmacyActiveList &&
                                <div className="row active-list-container">
                                    <div className="col-12">
                                        <ActiveList
                                            grantOrSubjectList={grantPharmacyActiveList}
                                            proxySource={RX}
                                            referrer="acceptgrant"
                                            approvedRequest={this.approvedRequest}
                                            isApprovePending={isChangeRequestActionApproveWaiting}
                                            approveRequestId={approveRequestId}
                                            approvedRequestSuccess={approvedRequestSuccess}
                                            actionType={actionType} />
                                    </div>
                                </div>
                            }
                            {hasPharmacyPendingList &&
                                <div className="row pending-list-container">
                                    <div className="col-12">
                                        <WaitingOnOthers
                                            proxySource={RX}
                                            list={pharmacyPendingList} />
                                    </div>
                                </div>
                            }
                            {enableProxyGrantPharmacy && hasPendingGrantPharmacyList &&
                                <div className="row pending-list-container">
                                    <div className="col-12">
                                        <WaitingOnYou
                                            grantPharmacyList={pendingGrantPharmacyList}
                                            onApprove={grant => this.onApprove(grant)}
                                            onDecline={grant => this.onDecline(grant)}
                                            proxySource={RX}
                                            isApprovePending={isChangeRequestActionApproveWaiting}
                                            approveRequestId={approveRequestId}
                                            approveErrorMessage={approveErrorMessage}
                                            isDeclinePending={isChangeRequestActionDeclineWaiting}
                                            declineRequestId={declineRequestId}
                                            declineErrorMessage={declineErrorMessage}
                                            actionType={actionType}
                                        />
                                    </div>
                                </div>
                            }
                            {/*Show request v2 pharmacy Cancelled list */}
                            {
                                enableProxyRequestV2 && hasRequestRxCancelledList &&
                                <div className="row cancelled-list-container">
                                    <div className="col-12">
                                        <WaitingOnOthers
                                            proxySource={RX}
                                            hasRequestRxCancelledList={hasRequestRxCancelledList}
                                            requestRxCancelledList={requestRxCancelledList} />
                                    </div>
                                </div>
                            }
                            {showGrantProxyAccess && enableProxyGrantPharmacy && hasGrantPharmacyCancelledList &&
                                <div className="row cancelled-list-container">
                                    <div className="col-12">
                                        <WaitingOnYou
                                            proxySource={RX}
                                            hasGrantPharmacyCancelledList={hasGrantPharmacyCancelledList}
                                            grantPharmacyCancelledList={grantPharmacyCancelledList}
                                        />
                                    </div>
                                </div>
                            }
                            {/*Show request v2 pharmacy Declined list */}
                            {
                                enableProxyRequestV2 && hasRequestRxDeclinedList &&
                                <div className="row cancelled-list-container">
                                    <div className="col-12">
                                        <WaitingOnOthers
                                            proxySource={RX}
                                            hasRequestRxDeclinedList={hasRequestRxDeclinedList}
                                            requestRxDeclinedList={requestRxDeclinedList} />
                                    </div>
                                </div>
                            }
                            {/*Show request v2 pharmacy Expired list */}
                            {
                                enableProxyRequestV2 && hasRequestRxExpiredList &&
                                <div className="row cancelled-list-container">
                                    <div className="col-12">
                                        <WaitingOnOthers
                                            proxySource={RX}
                                            hasRequestRxExpiredList={hasRequestRxExpiredList}
                                            requestRxExpiredList={requestRxExpiredList} />
                                    </div>
                                </div>
                            }
                            {showGrantProxyAccess && enableProxyGrantPharmacy && hasGrantPharmacyExpiredList &&
                                <div className="row pending-list-container">
                                    <div className="col-12">
                                        <WaitingOnYou
                                            proxySource={RX}
                                            grantPharmacyExpiredList={grantPharmacyExpiredList}
                                            hasGrantPharmacyExpiredList={hasGrantPharmacyExpiredList}
                                        />
                                    </div>
                                </div>
                            }
                        </RXSubjects>
                        {!hasPharmacyLogin &&
                            <LinkRecord
                                to={{
                                    pathname: '/linkedaccounts',
                                    searchParams: "openPharmacy=true"
                                }}
                            />
                        }
                        {
                            pharmacyError &&
                            <ErrorMsg message="We are not able to show these accounts. Please try again later." />
                        }
                        {/*hasPharmacyLogin && hasPharmacydeclineList &&
                    <div className="row decline-list-container">
                        <div className="col-12">
                            <Declined pharmacyDeclinedList={pharmacyDeclineList} />
                        </div>
                    </div>
                */}
                    </FamilyManagementCard>
                }
                
              
                {isAdult && (removeBSWPharmacy ? hasMychartLogin : true) &&
                    <Button onClick={(e) => this.requestAccess(e)}>Request access</Button>
                }
            </div>
        ));
    }
}

const mapStateToProps = (state) => {

    return {
        history: state.session.history,
        emailProxyRequestId: state.common.emailProxyRequestId,
        emailProxyRequestErrMsg: state.common.emailProxyRequestErrMsg,
        proxySource: state.common.proxySource,
        requestType: state.common.requestType,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        hasMychartLogin: !state.common.epicEHRDown && state.domain.hm,
        showAccessAndProxiesList: state.session.serverData && state.session.serverData.ShowAccessAndProxiesList,
        changeRequestStatusAction: state.common[types.REQUEST_PROXY_CHANGE_STATUS],
        age: state.domain.age,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false,
        showGrantProxyAccess: state.session.serverData ? state.session.serverData.showGrantProxyAccess : false,
        declineProxyWithReason: state.session.serverData ? state.session.serverData.declineProxyWithReason : false,
        enableProxyGrantPharmacy: state.session.serverData ? state.session.serverData.enableProxyGrantPharmacy : false,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeRequestStatus: (proxyRequestId, proxySource, requestType, status) =>
            dispatch({ type: types.REQUEST_PROXY_CHANGE_STATUS, data: { proxyRequestId, proxySource, requestType, status } }),
        setTimeoutMessage: (actionType) => dispatch({ type: types.SET_PROXY_MESSAGE, data: { actionType } }),
        clearMessage: () => dispatch({ type: types.CLEAR_PROXY_MESSAGE }),
        initializeRequestData: () => {
            dispatch({ type: types.PROXY_REQUEST_DATA, pData: {} });
        }
    };
};
//const mapDispatchToProps = (dispatch) => ({
//    initializeRequestData: () => {
//        dispatch({ type: types.PROXY_REQUEST_DATA, pData: {} });
//    }
//});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MySubjects));